<div style="width:100%;height:100px;border:1px solid #002F87;background-color:#F18C8C;">

    <div style="width:100%;margin-top:0px;height:10px;">
        <div class="d-flex flex-row-reverse" style="width:100%;">
            <mat-icon aria-hidden="false" aria-label="Close" fontIcon="close" style="color:black;" class="mimic-button-hover" (click)="closeErrorBanner()"></mat-icon>
        </div>
    </div>
    
    <!-- <div style="margin-top:0px;height:30px;">
        <span class="d-flex justify-content-center align-items-center">
           <div style="margin-top:20px;">
            <span class="ace>-secondary-text-14pt-semi" style="font-size:36px;font-weight: bold !important;color: white;">{{displayText}}</span>
            </div>
        </span>
    </div> -->
    <div class="container">
        <!-- <div class="row">
            <div class="col-10"></div>
            <div class="col=1">
                <mat-icon aria-hidden="false" aria-label="Stop" fontIcon="error" style="color:black;"></mat-icon>
            </div>
        </div> -->

        <div class="row">
            <div col="3">
       
            </div>
            <div col="6">
                <span style="color:black;"><strong>{{displayText}}</strong></span>
            </div>
        </div>

        <div class="row" style="margin-top:5px;">
            <div col="3">

            </div>
            <div col="9">
                <span style="color:black;"><strong>Please try again, and if this error continues to occur, please contact your administrator.</strong></span>
                <!-- Error Id: XXXX-xXXX</strong></span> -->
            </div>
        </div>
    </div>

</div>
